import { COLOR_STROKE, COLOR_WH } from '../colors.constants';

export const colorsCard = {
  colorsCardBackground: 'transparent',
  colorsCardBorder: COLOR_STROKE,
  colorsCardBackgroundSecondary: COLOR_WH,
};
